import React, { useState } from "react";
import "./vikas.css";

const VikasKame = () => {
  const [filter, setFilter] = useState("all");

  const works = [
    {
      title: "जिल्हा वार्षिक निधी 24/25 - स्मशान भूमी रस्ता",
      desc: "स्मशान भूमीपर्यंतचा रस्ता बांधकाम पूर्णत्वास आले.",
      desc:
        "१) रस्ता बांधकाम\n" +
        "२) नाली बांधकाम\n" +
        "३) समाज मंदिर बांधकाम\n" +
        "४) सार्वजनिक शौचालय बांधकाम\n" +
        "५) सेग्रिगेशन शेड बांधकाम\n" ,
        
      year: "2024-25",
      status: "completed",
      image: "/images/ghat.jpeg",
    },
    {
      title: "रेन वॉटर हार्वेस्टिंग प्रकल्प",
      desc: "ग्रामपंचायत इमारतीवर रेन वॉटर हार्वेस्टिंग बसवले.",
       desc:
        "१) शोषखड्डे बांधकाम\n" +
        "२) शाळा इमारत बांधकाम\n" +
        "३) गावात ठिकठिकाणी फलक लावणे\n" +
        "४) रस्त्याचे सिमेंटीकरण करणे व गट्टू बसविणे\n" +
        "५) परसबाग\n" ,
        
      year: "2024-25",
      status: "completed",
      image: "/images/rainwater.jpeg",
    },
    {
      title: "रस्ता डांबरीकरण",
      desc: "मुख्य रस्त्याचे डांबरीकरण पूर्ण.",
      year: "2023-24",
      status: "completed",
      image: "/images/damber.jpeg",
    },

    {
      title: "पाणीपुरवठा लाईन काम",
      desc: "नवीन पाणी लाईन टाकण्याचे काम सुरू आहे.",
      year: "2025",
      status: "ongoing",
      image: "/images/waterline.jpeg",
    },
    {
      title: "ग्रामपंचायत सुशोभीकरण",
      
      desc:
      "१) बचत भवन बांधकाम\n" +
        "२) शोकसभा मंडप\n" +
        "३) समाज भवन बांधकाम\n" +
        "४) नाली बांधकाम\n" +
        "५) शाळा दुरुस्ती बांधकाम\n" +
        "६) गावात रंगरंगोटी\n" +
        "७) वृक्ष संगोपन\n" +
        "८) नवीन नळ योजनेचे काम\n" +
        "९) पिण्याच्या पाण्याची टाकी\n" +
        "१०) इमारत बांधकाम\n" +
        "११) बौद्ध विहार दुरुस्ती व बांधकाम\n" ,
        

      year: "2025",
      status: "ongoing",
      image: "/images/garden.jpeg",
    },

    {
      title: "🟡 सुरू असणारी विकास कामे",
      desc:
        "१) नाली बांधकाम\n" +
        "२) स्मशान घाट बांधकाम\n" +
        "३) सार्वजनिक शौचालय बांधकाम\n" +
        "४) सीसी रोड बांधकाम\n" +
        "५) शाळा इमारत बांधकाम\n" +
        "६) बौद्ध विहार बांधकाम\n" +
        "७) स्ट्रीट लाईट बसविणे\n" +
        "८) पिण्याच्या पाण्याची सुविधा सुधारणा\n" +
        "९) नवीन विहीर बांधकाम\n" +
        "१०) हँडपंप दुरुस्ती\n" +
        "११) कचरा व्यवस्थापन\n" +
        "१२) वृक्ष लागवड\n" +
        "१३) ग्राम सौंदर्यीकरण",
      year: "2025",
      status: "ongoing",
    },

    {
      title: "🏛️ ग्रामपंचायत सुविधा",
      desc:
        "१) ग्रामपंचायत कार्यालय\n" +
        "२) सभागृह\n" +
        "३) सार्वजनिक स्वच्छतागृह\n" +
        "४) पाणीपुरवठा सुविधा",
      year: "नियमित",
      status: "completed",
    },
  ];

  const filteredWorks =
    filter === "all"
      ? works
      : works.filter((work) => work.status === filter);

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">🏗 विकास कामे</h2>

      <div className="filter-buttons">
        <button onClick={() => setFilter("all")}>सर्व</button>
        <button onClick={() => setFilter("completed")}>पूर्ण</button>
        <button onClick={() => setFilter("ongoing")}>चालू</button>
      </div>

      <div className="vikas-grid">
        {filteredWorks.map((work, index) => (
          <div className="vikas-card" key={index}>
            
            {work.image && (
              <img
                src={work.image}
                alt={work.title}
                className="work-image"
                onError={(e) => (e.target.style.display = "none")}
              />
            )}

            <span
              className={`status-badge ${
                work.status === "completed" ? "done" : "progress"
              }`}
            >
              {work.status === "completed" ? "✔ पूर्ण" : "⏳ चालू"}
            </span>

            <h3 className="work-title">{work.title}</h3>

            <p className="work-desc">
              {work.desc}
            </p>

            <p className="work-year">📅 {work.year}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VikasKame;